import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './par-city.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ParCityDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const parCityEntity = useAppSelector(state => state.parCity.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="parCityDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.parCity.detail.title">ParCity</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{parCityEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.parCity.code">Code</Translate>
            </span>
          </dt>
          <dd>{parCityEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.parCity.name">Name</Translate>
            </span>
          </dt>
          <dd>{parCityEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.parCity.nameAr">nameAr</Translate>
            </span>
          </dt>
          <dd>{parCityEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.parCity.nameEn">nameEn</Translate>
            </span>
          </dt>
          <dd>{parCityEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.parCity.status">Status</Translate>
            </span>
          </dt>
          <dd>{parCityEntity.status}</dd>
          <dt>
            <Translate contentKey="almobadaraMasterDataApp.parCity.region">Region</Translate>
          </dt>
          <dd>{parCityEntity.region ? parCityEntity.region.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/par-city" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/par-city/${parCityEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ParCityDetail;
